module.exports = __webpack_public_path__ + "img/SeiwaEv-logo.d1e86778.png";